import type { ReactNode } from 'react';
import { ListPageLayout } from '@shared/components/ListPageLayout';
import ShortcutsSidebar, { useShortcutLinks } from './ShortcutsSidebar';

type TProps = {
  children: ReactNode;
  stableScrollbarGutter?: boolean;
};

const ShortcutsLayout = ({ children, stableScrollbarGutter }: TProps) => {
  const hasShortcuts = useShortcutLinks().length > 0;

  return (
    <ListPageLayout
      nav={hasShortcuts ? <ShortcutsSidebar /> : null}
      canvas={hasShortcuts}
      stableScrollbarGutter={stableScrollbarGutter}
    >
      {children}
    </ListPageLayout>
  );
};

export default ShortcutsLayout;
